import React, { useContext } from 'react'
import Select from 'react-select'

import { ThemeContext } from '../../components/ThemeContext'

type Props = {
    options: Array<{ value: string; label: string }>
    value?: { value: string; label: string }
    onChange: (value: string) => void
    placeholder: string
    noOptionsMessage: string
    isOptionDisabled?: (value: string) => boolean
    isDisabled: boolean
}

const MultilineSelect: React.FC<Props> = (props) => {
    const { theme } = useContext(ThemeContext)

    return (
        <Select
            isDisabled={props.isDisabled}
            className="max-w-[1230px]"
            classNames={{
                control: () => 'text-sm',
                menu: () => 'text-sm',
                indicatorSeparator: () => 'hidden',
            }}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: props.isDisabled
                        ? theme == 'dark'
                            ? '#1F1E1F'
                            : '#d4d6d8'
                        : theme == 'dark'
                          ? '#181818'
                          : '#FFFFFF',
                    borderColor: props.isDisabled
                        ? theme == 'dark'
                            ? '#2A282B'
                            : '#b8b8b8'
                        : theme == 'dark'
                          ? '#181818'
                          : '#FFFFFF',
                    color: theme == 'dark' ? '#FFFFFF' : '#181818',
                    '&:hover': {
                        backgroundColor: props.isDisabled
                            ? theme == 'dark'
                                ? '#1F1E1F'
                                : '#d4d6d8'
                            : theme == 'dark'
                              ? '#181818'
                              : '#FFFFFF',
                    },
                    borderRadius: '5px',
                    minHeight: 0,
                    boxShadow: 'none', // отключаем фокусную тень, если не нужна
                }),
                valueContainer: (baseStyles) => ({
                    ...baseStyles,
                    padding: '0 0.5rem',
                }),
                indicatorsContainer: (baseStyles) => ({
                    ...baseStyles,
                    '> div': {
                        padding: '0',
                    },
                }),
                input: (baseStyles) => ({
                    ...baseStyles,
                    color: theme == 'dark' ? '#FFFFFF' : '#181818',
                }),
                singleValue: (baseStyles) => ({
                    ...baseStyles,
                    color: theme == 'dark' ? '#FFFFFF' : '#181818',
                }),
                menu: (baseStyles) => ({
                    ...baseStyles,
                    color: theme == 'dark' ? '#FFFFFF' : '#181818',
                    backgroundColor: theme == 'dark' ? '#181818' : '#FFFFFF',
                    borderRadius: '5px',
                    marginTop: '4px',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                }),
                option: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: state.isDisabled
                        ? theme == 'dark'
                            ? '#181818'
                            : '#FFFFFF'
                        : state.isFocused
                          ? theme == 'dark'
                              ? '#656365'
                              : '#e1e1e1'
                          : theme == 'dark'
                            ? '#181818'
                            : '#FFFFFF',
                    color: state.isDisabled
                        ? theme == 'dark'
                            ? '#8A8A8A'
                            : '#6A6A6A'
                        : theme == 'dark'
                          ? '#FFFFFF'
                          : '#181818',
                    opacity: state.isDisabled ? 0.5 : 1,
                    borderRadius: '0px', // обнулим, чтобы исключить переполнение
                    margin: 0, // убираем отступы, чтобы не выбивалось
                    padding: '8px 12px',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word', // важное добавление
                    overflowWrap: 'break-word', // тоже помогает
                    boxSizing: 'border-box',
                    maxWidth: '100%',
                }),
            }}
            options={props.options}
            value={props.value}
            onChange={(newValue) => props.onChange(newValue?.value ?? '')}
            placeholder={props.placeholder}
            noOptionsMessage={() => props.noOptionsMessage}
            isOptionDisabled={(option) =>
                props.isOptionDisabled != null
                    ? props.isOptionDisabled(option.value)
                    : false
            }
        />
    )
}

export default MultilineSelect
